import React from 'react';
import PropTypes from 'prop-types';

const EmptyLayout = ({ children }) => <div>{children}</div>;

EmptyLayout.propTypes = {
  children: PropTypes.node,
};

export default EmptyLayout;
